(() => {
  const bar = document.querySelector('.d2f-satc');
  if (!bar || bar.dataset.d2fContactObserved) return;
  bar.dataset.d2fContactObserved = 'true';
  const update = () => {
    const height = bar.getBoundingClientRect().height;
    if (height > 0) {
      const value = `${height}px`;
      if (document.documentElement.style.getPropertyValue('--d2f-contact-cart-height') !== value) document.documentElement.style.setProperty('--d2f-contact-cart-height', value);
    }
  };
  new ResizeObserver(update).observe(bar);
  update();
})();
